var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast-container"},_vm._l((_vm.toasts),function(t,idx){return _c('div',{key:idx,staticClass:"toast",class:t.type},[_c('span',{staticClass:"toast-icon"},[_vm._v(_vm._s(_vm.iconMap[t.type]))]),_c('span',[_vm._v(_vm._s(t.message))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }